 <template>
    <div class="form-group m-form__group row" :class="{'has-danger': form.errors.has(property)}">
        <label class="col-lg-3 col-form-label">{{ controlLabel }}</label>

        <div class="col-md-9 d-flex align-items-center">
            <slot :value="value">
                <input type="text" class="form-control  m-input" :name="property" v-model="value">
            </slot>
            <!--<span class="m-form__help">Please enter your full name</span>-->
            <span class="form-control-feedback" v-show="form.errors.has(property)">
                {{ form.errors.get(property) }}
            </span>
        </div>
    </div>
 </template>
<script>
import dgs from 'lib/dotgetset/index';

export default {
    props: ['form', 'property', 'label','trans'],
    computed: {
        controlLabel() {
            return this.label || this.property.split('.')[0].replace(/_id$/, '').split('_').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(' ');
        },
        value: {
            get: function () {
                return dgs.getValue(this.property, this.form);
            },
            set: function (newValue) {
                dgs.setValue(this.property, this.form, newValue);
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/form/Input.vue